import React from "react";
import Layout from "../organisms/layout";

const ProductHomePage = () => {
  return (
    <div>
      <Layout />
    </div>
  );
};

export default ProductHomePage;
